export function DragnDrop(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.3 3H16.6993C17.887 2.99919 18.9633 3.6991 19.4439 4.78397L22.905 12.5741C22.9659 12.7033 23 12.8477 23 13V18C23 19.6569 21.6569 21 20 21H4C2.34315 21 1 19.6569 1 18V13C1 12.8477 1.03406 12.7033 1.09497 12.5741L4.55593 4.78444C5.03706 3.69886 6.11323 2.99919 7.3 3ZM3 14V18C3 18.5523 3.44772 19 4 19H20C20.5523 19 21 18.5523 21 18V14H16.5352L14.8321 16.5547C14.6466 16.8329 14.3344 17 14 17H10C9.66565 17 9.35342 16.8329 9.16795 16.5547L7.46482 14H3ZM20.4614 12H16C15.6656 12 15.3534 12.1671 15.1679 12.4453L13.4648 15H10.5352L8.83205 12.4453C8.64658 12.1671 8.33435 12 8 12H3.53856L6.38432 5.595C6.54465 5.23303 6.90343 4.99973 7.29932 5L16.7 5C17.0966 4.99973 17.4553 5.23303 17.6157 5.595L20.4614 12Z"
        fill="#2A4AF4"
      />
    </svg>
  );
}
